import { Alert, ErrorScreen } from 'components/common';
import { Backdrop, CircularProgress } from '@mui/material';
import { useUserManager } from 'components/hooks';
import { ROUTES } from 'consts';
import withRequest from 'hoc/withRequest';
import React, {useEffect, useLayoutEffect, useState} from 'react'
import { useHistory, withRouter } from 'react-router-dom';
import UserFormDumb from './UserFormDumb';

const UserEditSmart = (props) => {
  const history = useHistory();
  const { cleanUpMessage, data, error, success, isLoaded ,putUser, getUser} = useUserManager();
  const { match: { params } } = props;
  const { username } = params;

  const [defaultValues, setDefaultValues] = useState({
    username: '',
    firstname: '',
    surname: '',
    email: '',
    password: '',
    active: true,
    admin: false,
    roles: [],
    role: ''
  });

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    putUser({
      body: {...data},
    });
  };

  const handleData = () => {
    // const roles = data.roles.map(c => ({
    //   id: c.roleId,
    //   label: c.roleName,
    //   text: c.roleDescription,
    // }));
    setDefaultValues({...defaultValues, ...data, roles: data.roles});
  }

  useLayoutEffect(() => {
    getUser({
      query: { username },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!!success.put) history.push(ROUTES.USER_LIST);
    else if (!!success.get) handleData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.put, success.get]);

  return (
    <>
    { error.get ?
      (
        <ErrorScreen />
      ): isLoaded.get ?
      (
        <Backdrop
        invisible
        sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
        open={true}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      ) : (
        <UserFormDumb
          defaultValues={defaultValues}
          handleOnSubmit={handleEdit}
          isEdit={true}
        />
      )
    }
    <Alert
      severity="error"
      handleClose={handleCloseAlert}
      open={error.put}
      message="common.errors.general.title" />
    </>
  )
}

export default withRequest(withRouter(UserEditSmart));
